import React from 'react';

const PrivacyPolicyPage = () => {
  return <>PrivacyPolicyPage</>;
};

export default PrivacyPolicyPage;
